<template>
  <div v-if="this.language == 'en'">
    <LoadingScreen :isLoading="isLoading" />
    <div class="login" v-if="!isLoading">
      <div class="fixed left-0 right-0 top-2/6">
        <img class="mx-auto" src="../assets/images/freshest-flick-malay.png" alt="">
      </div>
      <div class="absolute bottom-0 bg-linear-5 rounded-t-2xl p-5 w-full text-center">
        <p class="mb-5 text-sm font-bold text-green-1">{{ $t("login_title") }}</p>
          <div class="flex flex-col gap-5">
            <button @click="signIn('Google')" class="bg-linear-7 py-4 block w-full rounded-xl flex items-center justify-center gap-6 text-base text-white font-bold"><img src="../assets/images/google.svg" alt="">{{ $t("login_social") }} GOOGLE</button>
            <button @click="signIn('Facebook')" class="bg-gradient-to-r from-blue-400 to-blue-700 py-4 block w-full rounded-xl flex items-center justify-center gap-7 text-base text-white font-bold"><img src="../assets/images/facebook.svg" alt="">{{ $t("login_social") }} FACEBOOK</button>
          </div>
        <div @click="$parent.sfx.touch.play()">
          <router-link to="terms-and-condition-first">
            <span class="my-3.5 text-sm font-bold text-center text-green-1 block underline">*{{ $t('homepage_modal_terms') }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <LoadingScreen :isLoadingThai="isLoadingThai" />
    <div class="login" v-if="!isLoadingThai">
      <div class="fixed left-0 right-0 top-2/6">
        <img class="mx-auto" src="../assets/images/freshest-flick-thai.png" alt="">
      </div>
      <div class="absolute bottom-0 bg-linear-5 rounded-t-2xl p-5 w-full text-center">
        <p class="mb-5 text-sm font-bold text-green-1">{{ $t("login_title") }}</p>
          <div class="flex flex-col gap-5">
            <button @click="signIn('Google')" class="bg-linear-7 py-4 block w-full rounded-xl flex items-center justify-center gap-6 text-base text-white font-bold"><img src="../assets/images/google.svg" alt="">{{ $t("login_social") }} GOOGLE</button>
            <button @click="signIn('Facebook')" class="bg-gradient-to-r from-blue-400 to-blue-700 py-4 block w-full rounded-xl flex items-center justify-center gap-7 text-base text-white font-bold"><img src="../assets/images/facebook.svg" alt="">{{ $t("login_social") }} FACEBOOK</button>
          </div>
        <div @click="$parent.sfx.touch.play()">
          <router-link to="terms-and-condition-first">
            <span class="my-3.5 text-sm font-bold text-center text-green-1 block underline">*{{ $t('homepage_modal_terms') }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Button from '@/components/Button.vue'
import LoadingScreen from '@/components/LoadingScreen'
import { mapActions } from 'vuex'

export default {
  metaInfo() {
    return {
      title: "Login"
    };
  },
  name: 'Login',
  components: {
    // Button
    LoadingScreen
  },
  data() {
    return { 
      isLoading: true,
      isLoadingThai: true,
      language: '' 
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
      this.isLoadingThai = false;
    }, 2000);

    this.language = process.env.VUE_APP_I18N_LOCALE
		console.log(this.language)
  },
  methods: {
    ...mapActions([
      'signInWith'
    ]),
    signIn (option) {
      this.signInWith(option)
    }
  }
}
</script>
